﻿(function (document) {
    function updateCountdown(element) {

        var now = new Date();

        var timeRemaining = element.dataset.countdown - now;

        var minutesRemaining = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        var secondsRemaining = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        element.innerText = minutesRemaining + (secondsRemaining < 10 ? ":0" : ":") + secondsRemaining;

        if (new Date(element.dataset.countdownWarning - 0) < now) {
            document.querySelector('.basket-timer').classList.add('basket-timer--warning');
        }

        if (new Date(element.dataset.countdown - 0) < now) {
            document.querySelector('.basket-timer p').innerText = element.dataset.countdownExpiryHeader;
            if (!(window.PaymentAuthenticationInProgress || window.PaymentInProgress)) {
                document.ShowModal(document.querySelector('.checkout-modal__container'));
            }
        } else {
            requestAnimationFrame(function () {
                updateCountdown(element)
            });
        }
    }

    document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll('[data-countdown]').forEach(function (element) {
            fetch(
                '/api/basket/time-remaining', {
                method: 'GET',
                credentials: 'same-origin'
            }).then(function (response) {
                return response.json();
            }).then(function (data) {
                if (data.IsStockReserved) {
                    element.dataset.countdown = new Date().setSeconds(new Date().getSeconds() + data.TimeRemaining);
                }

                updateCountdown(element);
            });
        });
    });

})(document);